import React from 'react';
import { cookieTable } from '../../data/cookies';
import { openCookiePreferences } from '../../utils/consent';
export default function CookiePolicySection() {
  return <div className="p-6 bg-white" data-id="element-344" data-mp="3kekcuimlnxqi">
      <p className="text-slate-dark mb-4" data-id="element-345" data-mp="26uv4juvyg10">
        Cookies are small text files placed on your device when you visit a
        website. Our website, medicolegal-psychiatry.co.uk, uses one essential
        storage item to remember your cookie choices. Analytics and marketing
        cookies are only set if you agree to them.
      </p>
      <h3 className="text-lg font-bold text-primary mb-2" data-id="element-346" data-mp="31nkptmyo0xzv">
        a) Your choice
      </h3>
      <p className="text-slate-dark mb-4" data-id="element-347" data-mp="3fepmcg6qla5z">
        When you first visit, a banner asks whether you accept or reject
        optional cookies. Rejecting is as easy as accepting, and no analytics
        or marketing script runs until you choose. Your choice is kept for 12
        months, after which we ask again. You can change or withdraw your
        consent at any time; withdrawal does not affect processing carried out
        before it.
      </p>
      <button type="button" onClick={openCookiePreferences} className="mb-6 min-h-[44px] rounded-md bg-primary px-5 py-2.5 text-sm font-semibold text-white transition-colors duration-150 hover:bg-primary-light focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary focus-visible:ring-offset-2" data-id="element-348" data-mp="3p0r0c99jkv2k">
        Change cookie preferences
      </button>
      <h3 className="text-lg font-bold text-primary mb-2" data-id="element-349" data-mp="3626d4saru9u7">
        b) Categories we use
      </h3>
      <ul className="list-disc pl-6 mb-4 text-slate-dark" data-id="element-350" data-mp="3b1rd961ogo8i">
        <li className="mb-2" data-id="element-351" data-mp="3b07xdgjxof79">
          Strictly necessary: remembers your cookie choice. This cannot be
          switched off, because the site could not respect your choice without
          it.
        </li>
        <li className="mb-2" data-id="element-352" data-mp="qdd1srqic86e">
          Analytics (Google Analytics and Microsoft Clarity): measures visits
          and records how visitors move through pages, including scrolling and
          clicks, shown to us as anonymised session recordings and heatmaps. We
          configure Clarity to mask on-page text and form entries, and Google
          Analytics to anonymise IP addresses. We use this to find where the
          site is unclear to instructing solicitors.
        </li>
        <li data-id="element-353" data-mp="2vfwg6wuksgw6">
          Marketing (LinkedIn Insight Tag): measures the results of our
          LinkedIn advertising and allows us to show adverts on LinkedIn to
          professionals who have visited the site. LinkedIn provides us with
          aggregated reports only; we cannot identify individual visitors.
        </li>
      </ul>
      <h3 className="text-lg font-bold text-primary mb-2" data-id="element-354" data-mp="2covman8bbbjh">
        c) Cookies in detail
      </h3>
      <div className="mb-4 overflow-x-auto rounded-lg border border-gray-200" role="region" aria-label="Cookies used on this website" tabIndex={0} data-id="element-355" data-mp="1oyrhicje15qw">
        <table className="w-full min-w-[40rem] border-collapse text-left text-sm" data-id="element-356" data-mp="3vnbdtmtcgmpt">
          <caption className="sr-only" data-id="element-357" data-mp="3vl706d5n89cc">
            Cookie name, provider, category, purpose and duration
          </caption>
          <thead className="bg-gray-50" data-id="element-358" data-mp="3mmvb4fkfdjm0">
            <tr data-id="element-359" data-mp="3mnwlsixj4437">
              <th scope="col" className="px-4 py-3 font-semibold text-primary" data-id="element-360" data-mp="3mog5a42tv0jc">Name</th>
              <th scope="col" className="px-4 py-3 font-semibold text-primary" data-id="element-361" data-mp="3rm7wevvneimh">Provider</th>
              <th scope="col" className="px-4 py-3 font-semibold text-primary" data-id="element-362" data-mp="j77qjt3ecgsu">Category</th>
              <th scope="col" className="px-4 py-3 font-semibold text-primary" data-id="element-363" data-mp="n66t571no1h4">Purpose</th>
              <th scope="col" className="px-4 py-3 font-semibold text-primary" data-id="element-364" data-mp="96nm6hkkyw6e">Duration</th>
            </tr>
          </thead>
          <tbody data-id="element-365" data-mp="e58pwqz1jxzl">
            {cookieTable.map(cookie => <tr key={cookie.name} className="border-t border-gray-200 align-top" data-id="element-366" data-mp="2txodrjwpj02c">
                <th scope="row" className="px-4 py-3 font-mono text-xs font-medium text-slate-dark break-words" data-id="element-367" data-mp="2ywr6c4vi3dtf">
                  {cookie.name}
                </th>
                <td className="px-4 py-3 text-slate-dark" data-id="element-368" data-mp="3e8sbp4d1n95z">{cookie.provider}</td>
                <td className="px-4 py-3 text-slate-dark whitespace-nowrap" data-id="element-369" data-mp="39eedyvawspy5">{cookie.category}</td>
                <td className="px-4 py-3 text-slate-dark" data-id="element-370" data-mp="35evodm857qoz">{cookie.purpose}</td>
                <td className="px-4 py-3 text-slate-dark" data-id="element-371" data-mp="30gc2fltjuewm">{cookie.duration}</td>
              </tr>)}
          </tbody>
        </table>
      </div>
      <h3 className="text-lg font-bold text-primary mb-2" data-id="element-372" data-mp="3t3yhbq8895ys">
        d) Third-party privacy notices
      </h3>
      <ul className="list-disc pl-6 mb-4 text-slate-dark" data-id="element-373" data-mp="3o4lj69bwocgw">
        <li className="mb-2" data-id="element-374" data-mp="3o30q6o58p1l5">
          Google:{' '}
          <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-primary underline hover:text-secondary" data-id="element-375" data-mp="3j6ad89oqem3y">
            Google Privacy Policy
          </a>
        </li>
        <li className="mb-2" data-id="element-376" data-mp="27pk9cx7s66di">
          Microsoft:{' '}
          <a href="https://privacy.microsoft.com/privacystatement" target="_blank" rel="noopener noreferrer" className="text-primary underline hover:text-secondary" data-id="element-377" data-mp="1xmory4jqkscu">
            Microsoft Privacy Statement
          </a>
        </li>
        <li data-id="element-378" data-mp="27kkyej1qaz4m">
          LinkedIn:{' '}
          <a href="https://www.linkedin.com/legal/cookie-policy" target="_blank" rel="noopener noreferrer" className="text-primary underline hover:text-secondary" data-id="element-379" data-mp="27jjpol86qoq2">
            LinkedIn Cookie Policy
          </a>
        </li>
      </ul>
      <p className="text-slate-dark" data-id="element-380" data-mp="2lbzk4xn0tefd">
        You can also block or delete cookies through your browser settings.
        Some third-party cookies set on the providers' own domains can only be
        removed this way.
      </p>
    </div>;
}